import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  // from something application/pdf image/jpeg to .pdf .jpeg
  function getExtensionFromType(type: string): string {
    const split = type.split("/");
    if (split[1]) {
      return `.${split[1]}`;
    }
    return "no extension";
  }

  return {
    getExtensionFromType,
  };
}
